import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.4 12a.9.9 0 0 1 .9-.9h15.108l-2.52-2.34a.9.9 0 0 1 1.224-1.32l4.2 3.9a.9.9 0 0 1 0 1.32l-4.2 3.9a.9.9 0 1 1-1.224-1.32l2.52-2.34H3.3a.9.9 0 0 1-.9-.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }